import styled from 'styled-components/macro';
import { color, space } from 'styled-system';
import { Box, Flex } from 'components/ui';
import twitterIcon from 'img/twitter.svg';
import emailIcon from 'img/email.svg';
import openseaIcon from 'img/opensea-circle.svg';
import { twitterURL, contactEmail, openseaSocialLink } from 'utils/config';
import ContractsList from 'components/ContractsList';

const Hyperlink = styled.a`
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  ${color}
  ${space}
`;

const Footer = ({ fixed }) => (
  <Box
    backgroundColor="rgba(0, 0, 0, 0.4)"
    width="100%"
    display="block"
    margin="0 auto"
    borderTop="1px solid #444"
    zIndex="3"
    p={['24px', '24px 56px 24px 40px']}
    fontSize="14px"
    position={fixed ? ['relative', 'absolute'] : 'relative'}
    bottom="0"
  >
    <Flex justifyContent="space-between" flexDirection={['column', 'row', 'row']}>
      <Box display="flex" flexDirection="column" justifyContent="space-between">
        <Flex mb={4}>
          <Box mr={5}>
            <Hyperlink
              color="copy"
              href="https://eulerbeats.gitbook.io/eulerbeats-docs/eulerbeats-terms-of-service-tl-dr"
              target="_blank"
            >
              Terms of Service
            </Hyperlink>
          </Box>
          <Box mr={5}>
            <Hyperlink
              color="copy"
              href="https://eulerbeatsprod.blob.core.windows.net/miscellaneous/grants-program-terms.pdf"
              target="_blank"
            >
              Grant Program Terms
            </Hyperlink>
          </Box>
          <ContractsList />
        </Flex>

        <Box display="flex" mb={[4, 0]}>
          <Box color="#CCCCCC">© 2025 EulerBeats</Box>
          <Box color="#CCCCCC" mx={3}>
            •
          </Box>
          <Box color="#CCCCCC">A Consensys Formation</Box>
        </Box>
      </Box>

      <Box display="flex" alignItems="center">
        <Box mr={4}>
          <Hyperlink color="copy" href={openseaSocialLink} target="_blank" rel="noopener noreferrer">
            <img src={openseaIcon} alt="OpenSea" width="30px" color="white" />
          </Hyperlink>
        </Box>
        <Box mr={4}>
          <Hyperlink color="copy" href={twitterURL} target="_blank" rel="noopener noreferrer">
            <img src={twitterIcon} alt="@eulerbeats" width="30px" color="white" />
          </Hyperlink>
        </Box>
        <Box>
          <Hyperlink
            color="copy"
            href={`mailto:${contactEmail}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={emailIcon} alt={contactEmail} width="30px" />
          </Hyperlink>
        </Box>
      </Box>
    </Flex>
  </Box>
);

export default Footer;
